import { App, View } from "@pimo/pimo-app-builder";
import { DragAndDropLayout, PMDescriptionCard } from "@pimo/pimo-components";

import { TestAppState } from "../../../app";
import { makeGetCardCopy } from "../card-copy";

/** Adds the management summary card (#2222). */
export function addManagementSummaryCard(
  view: View<TestAppState, DragAndDropLayout>,
  app: App<TestAppState>
) {
  const language = app.getAppState().language || "en";
  const getCardCopy = makeGetCardCopy(app);

  const managementSummaryComponent = view.addComponent({
    component: PMDescriptionCard,
    layoutProps: {
      componentId: "managementSummaryComponent",
      labels: ["description"],
      description: getCardCopy(language, "reportManagementSummary").description,
      title: getCardCopy(language, "reportManagementSummary").title,
    },
  });
  managementSummaryComponent.mapState(({ currentReport, language }) => {
    return {
      title: getCardCopy(language, "reportManagementSummary").title,

      text: currentReport?.project?.managementSummary ?? "",
    };
  });
  managementSummaryComponent.mapVisibility(
    ({ settings }) =>
      (
        settings?.configuration?.fieldsDefinition?.filter(
          (field) => field.purpose === "projectReporting"
        ) ?? []
      ).find((field) => field.fieldName === "managementSummary")?.enabled ===
      true
  );
}
